import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import staff2 from '../../../../images/staff/member_2.png';
import { Row, Col, Tab, Nav } from "react-bootstrap";
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import axios from 'axios';
import bgimage from '../../../../images/items/items.jpg'; 
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
dayjs.extend(isBetween);

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
          diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff)); 
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
          diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};
const baseURL = process.env.REACT_APP_API_BASE_URL;


const StockIn = () => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [loading, setLoading] = useState(false);
    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    // page table data fetch
    const fetchData = (filter = {}) => {
        setLoading(true); 
        const params = {
            ...filter,
            page,
            per_page: perPage,
            search: searchTerm,
            branch_id: branch_id
        };
        axios.get(`${baseURL}/stock/stock_in`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            })
        .finally(() => {
            setLoading(false); // ⬅️ Stop skeleton
        });
    };

    // fetch data
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);


    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const tableRef = useRef(null);

    const [filterOpen, setFilterOpen] = useState(false);

    const onClose = () => {
        setFilterOpen(false);
    };


    const date_fil_options_stock = [
        { value: "all", label: "All" },
        { value: "yesterday", label: "Yesterday" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] =  useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());
    const [yest_fil_value, setYestFilValue] = useState(dayjs().subtract(1, 'day').toDate());
    const [today_fil_value, setTodayFilValue] = useState(new Date());


    useEffect(() => {
        const params = {
            date_filter: date_fil_selt_value,
        };
        if (date_fil_selt_value === 'yesterday') {
            params.start_date = dayjs(yest_fil_value).format('DD-MM-YYYY');
            params.end_date = dayjs(yest_fil_value).format('DD-MM-YYYY');
        } else if (date_fil_selt_value === 'this_week') {
            params.start_date = dayjs(week_stdt_fil_value).format('DD-MM-YYYY');
            params.end_date = dayjs(week_eddt_fil_value).format('DD-MM-YYYY');
        } else if (date_fil_selt_value === 'this_month') {
            const startOfMonth = dayjs(month_fil_value).startOf('month').format('DD-MM-YYYY');
            const endOfMonth = dayjs(month_fil_value).endOf('month').format('DD-MM-YYYY');
            params.start_date = startOfMonth;
            params.end_date = endOfMonth;
        } else if (date_fil_selt_value === 'custom') {
            params.start_date = dayjs(custom_stdt_fil_value).format('DD-MM-YYYY');
            params.end_date = dayjs(custom_eddt_fil_value).format('DD-MM-YYYY');
        }
        fetchData(params);

    }, [date_fil_selt_value, custom_stdt_fil_value, custom_eddt_fil_value, month_fil_value, week_stdt_fil_value, week_eddt_fil_value]);


    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    "pageLength": 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                {/* <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Stocks In</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Stock Management</li>
                    </ol>
                </div> */}
                {loading ? (
                    <>
                        {/* LEFT SIDE Skeleton */}
                        <div className="mb-0">
                            <div className="mb-0 px-0">
                                <Skeleton width={220} height={28} />
                            </div>

                            <ol className="breadcrumb fs-7">
                                <li className="breadcrumb-item"><Skeleton width={100} height={18} /></li>
                                <li className="breadcrumb-item"><Skeleton width={40} height={18} /></li>
                                <li className="breadcrumb-item"><Skeleton width={140} height={18} /></li>
                            </ol>
                        </div>

                       
                    </>
                ) : (
                    <>
                        {/* LEFT SIDE Actual UI */}
                        <div className="mb-0">
                            <div className="mb-0 px-0">
                                <h4 className="breadcrumb-header">Manage Stocks In</h4>
                            </div>
                            <ol className="breadcrumb fs-7">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                                <li className="breadcrumb-item active">Stock Management</li>
                            </ol>
                        </div>

                      
                    </>
                )}
                
            </div>
            <Row>
                <Col xl={12}>

                    <div className='row mb-4'>
                        <div className="col-lg-3 mb-2">
                            {/* <label className="text-black font-w500 fs-7">Date</label>
                            <Select
                                value={date_fil_options_stock.find(option => option.value === date_fil_selt_value)}
                                onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                options={date_fil_options_stock}

                            />
                                */}
                        {loading ? (
                                <>
                                    {/* Skeleton for Label */}
                                    <Skeleton width={60} height={12} className="mb-2" />

                                    {/* Skeleton for Select Input */}
                                    <Skeleton height={38} />
                                </>
                            ) : (
                                <>
                                    {/* Actual Label */}
                                    <label className="text-black font-w500 fs-7">Date</label>

                                    {/* Actual Select */}
                                    <Select
                                        value={date_fil_options_stock.find(option => option.value === date_fil_selt_value)}
                                        onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                        options={date_fil_options_stock}
                                    />
                                </>
                            )}
                        </div>
                        {date_fil_selt_value === "all" && <></>}
                        {date_fil_selt_value === "yesterday" && (
                            <div className="col-lg-3 mb-2">
                                <label className="text-black font-w500 fs-7">Yesterday</label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'>
                                        <i className='fa-solid fa-calendar-days fs-4'></i>
                                    </div>
                                    <DatePicker
                                        value={yest_fil_value}
                                        onChange={setYestFilValue}
                                        format="DD-MM-YYYY"
                                        readOnly={true}
                                    />
                                </div>
                            </div>
                        )}
                        {date_fil_selt_value === "this_week" && (
                            <>
                                <div className="col-lg-3 mb-2">
                                    <label className="text-black font-w500 fs-7">Start Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={week_stdt_fil_value}
                                            onChange={setWeekSTDTFilValue}
                                            format="DD-MM-YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-2">
                                    <label className="text-black font-w500 fs-7">End Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={week_eddt_fil_value}
                                            onChange={setWeekEDDTFilValue}
                                            format="DD-MM-YYYY"
                                            calendarPosition="top-end"
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        {date_fil_selt_value === "this_month" && (
                            <div className="col-lg-3 mb-2">
                                <label className="text-black font-w500 fs-7">This Month</label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker
                                        value={month_fil_value}
                                        onChange={setMonthFilValue}
                                        format="MMM-YYYY"
                                        calendarPosition="top"
                                        mode="single"
                                        onlyMonthPicker={true}
                                    />
                                </div>
                            </div>
                        )}
                        {date_fil_selt_value === "custom" && (
                            <>
                                <div className="col-lg-3 mb-2">
                                    <label className="text-black font-w500 fs-7">Start Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={custom_stdt_fil_value}
                                            onChange={setCustomSTDTFilValue}
                                            format="DD-MM-YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-2">
                                    <label className="text-black font-w500 fs-7">End Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={custom_eddt_fil_value}
                                            onChange={setCustomEDDTFilValue}
                                            format="DD-MM-YYYY"
                                            calendarPosition="top-end"
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    <div className="table-container">

                        {/* <div className="d-flex justify-content-between align-items-center mb-3"> 
                            <div>
                                <label className="me-2">Show</label>
                                <select
                                    className="form-select d-inline w-auto"
                                    style={{  fontSize: '0.85rem', height: '30px' }}
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(Number(e.target.value));
                                        setPage(1);  
                                    }}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
 
                            <div>
                                <input
                                    type="text"
                                    style={{  fontSize: '0.85rem', height: '40px' }}
                                    placeholder="Search..."
                                    className="form-control"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setPage(1);  
                                    }}
                                />
                            </div>
                        </div> */}
                        <div className="d-flex justify-content-between align-items-center mb-3">  
                        <div>
                            {loading ? (
                                <> 
                                    <Skeleton width={40} height={12} className="mb-1" />
 
                                    <Skeleton width={70} height={30} />
                                </>
                            ) : (
                                <>
                                    <label className="me-2">Show</label>
                                    <select
                                        className="form-select d-inline w-auto"
                                        style={{ fontSize: '0.85rem', height: '30px' }}
                                        value={perPage}
                                        onChange={(e) => {
                                            setPerPage(Number(e.target.value));
                                            setPage(1);
                                        }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50}</option>
                                        <option value={100}>100</option>
                                    </select>
                                </>
                            )}
                        </div>

                        <div>
                            {loading ? (
                                <> 
                                    <Skeleton width={150} height={40} />
                                </>
                            ) : (
                                <input
                                    type="text"
                                    style={{ fontSize: '0.85rem', height: '40px' }}
                                    placeholder="Search..."
                                    className="form-control"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setPage(1);
                                    }}
                                />
                            )}
                        </div> 
                    </div>

                        <table  className="item_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                            <thead>
                                {loading ? (
                                    <tr>
                                        <th><Skeleton width={90} height={12} /></th>
                                        <th><Skeleton width={120} height={12} /></th>
                                        <th className="text-center"><Skeleton width={80} height={12} /></th>
                                        <th><Skeleton width={150} height={12} /></th>
                                        <th className="text-center"><Skeleton width={90} height={12} /></th>
                                        <th className="text-center"><Skeleton width={100} height={12} /></th>
                                    </tr>
                                ) : (
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                        <th className='min-w-50px'>Raw Material / Brand</th>
                                        <th className='min-w-100px'>Stock Room</th>
                                        <th className='min-w-150px text-center'>Purchase/Expiry Date</th>
                                        <th className='min-w-100px text-start'>Purchase Quantity</th>
                                        <th className='min-w-75px text-center'>Vendor</th> 
                                    </tr>
                                )}
                            </thead>
                            
                            {/* <thead>
                                <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='min-w-200px'>Raw Material / Brand</th>
                                    <th className='min-w-100x text-start'>Stock Room</th>
                                    <th className='min-w-100x text-start'>Purchase/Expiry Date</th> 
                                    <th className='min-w-100px text-start'>Purchase Quantity</th>
                                    <th className='min-w-100x text-start'>Vendor</th>
                                </tr>
                            </thead> */}


                            {/* <tbody className="text-gray-600 fw-semibold fs-7">
                                {datas.length === 0 && hasFetched ? (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted py-2">
                                            No data available
                                        </td>
                                    </tr>
                                ) : (
                                    <>
                                        {datas.map((data, index) => (
                                            <tr>
                                                <td>
                                                    <div className='d-flex flex-row align-items-center justify-content-start gap-2'>
                                                        <LightGallery
                                                            onInit={onInit}
                                                            speed={500}
                                                            plugins={[lgThumbnail, lgZoom]}
                                                        >
                                                            <div data-src={data.image_url ? data.image_url : bgimage} className='border rounded px-1 py-0'>
                                                                <img src={data.image_url ? data.image_url : bgimage} alt={data.raw_material_name} className='cursor-pointer w-50px h-50px' />
                                                            </div>
                                                        </LightGallery>
                                                        <div className='d-flex flex-column align-items-start justify-content-start gap-1'>
                                                            <label className='text-black font-w400 fs-7 fw-bold'>{data.raw_material_name}</label>
                                                            <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Brand</span></Tooltip>} >
                                                                <label className='text-primary font-w500 fs-7'>{data.raw_material_brand_name ? data.raw_material_brand_name : '-'}</label>
                                                            </OverlayTrigger>
                                                        </div>

                                                    </div>
                                                </td>
                                                <td><div className='text-primary  fs-6 fw-semibold'>{data.stock_room_name || '-'}</div></td>
                                                <td>
                                                    <div className='text-primary  fs-6 fw-semibold'>{data.formatted_purchase_date}</div><div className='text-danger  fs-6 fw-semibold'>{data.formatted_expiry_date}</div>
                                                </td>
                                                
                                                <td>
                                                    <div className='d-flex flex-row align-items-start justify-content-start gap-1'>
                                                        <label className='text-black font-w600 fs-7 rounded py-1 px-2 border border-info'>{data.purchase_quantity} {data.purchase_unit}</label>
                                                    </div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className="d-flex align-items-start justify-content-start gap-2">
                                                        <LightGallery
                                                            onInit={onInit}
                                                            speed={500}
                                                            plugins={[lgThumbnail, lgZoom]}
                                                        >
                                                            <div data-src={data.vendor_image ? data.vendor_image : staff2} className='border rounded px-1 py-0'>
                                                                <img src={data.vendor_image ? data.vendor_image : staff2} alt={data.vendor_name} className='cursor-pointer w-50px h-50px' />
                                                            </div>
                                                        </LightGallery>
                                                        <div className='d-flex flex-column align-items-start'>
                                                            <label className='text-black font-w400 fs-7'>{data.vendor_name}</label>
                                                            <label className='text-dark font-w400 fs-7'>{data.vendor_category}</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                )}
                            </tbody> */}
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {loading ? (
                                    // Skeleton rows while loading
                                    [...Array(5)].map((_, index) => (
                                        <tr key={index}>
                                            {/* Raw Material + Brand */}
                                            <td>
                                                <div className='d-flex flex-row align-items-center justify-content-start gap-2'>
                                                    <Skeleton circle width={50} height={50} />
                                                    <div className='d-flex flex-column align-items-start justify-content-start gap-1'>
                                                        <Skeleton width={120} height={14} />
                                                        <Skeleton width={80} height={12} />
                                                    </div>
                                                </div>
                                            </td>

                                            {/* Stock Room */}
                                            <td>
                                                <Skeleton width={100} height={16} />
                                            </td>

                                            {/* Purchase & Expiry Dates */}
                                            <td>
                                                <Skeleton width={80} height={14} className='mb-1' />
                                                <Skeleton width={80} height={14} />
                                            </td>

                                            {/* Purchase Quantity */}
                                            <td>
                                                <Skeleton width={60} height={20} />
                                            </td>

                                            {/* Vendor */}
                                            <td className='text-center'>
                                                <div className="d-flex align-items-start justify-content-start gap-2">
                                                    <Skeleton circle width={50} height={50} />
                                                    <div className='d-flex flex-column align-items-start'>
                                                        <Skeleton width={100} height={14} className='mb-1' />
                                                        <Skeleton width={80} height={12} />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    // Actual data
                                    datas.length === 0 && hasFetched ? (
                                        <tr>
                                            <td colSpan="5" className="text-center text-muted py-2">
                                                No data available
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {datas.map((data, index) => (
                                                <tr key={index}>
                                                    {/* Raw Material + Brand */}
                                                    <td>
                                                        <div className='d-flex flex-row align-items-center justify-content-start gap-2'>
                                                            <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                                <div data-src={data.image_url ? data.image_url : bgimage} className='border rounded px-1 py-0'>
                                                                    <img src={data.image_url ? data.image_url : bgimage} alt={data.raw_material_name} className='cursor-pointer w-50px h-50px' />
                                                                </div>
                                                            </LightGallery>
                                                            <div className='d-flex flex-column align-items-start justify-content-start gap-1'>
                                                                <label className='text-black font-w400 fs-7 fw-bold'>{data.raw_material_name}</label>
                                                                <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Brand</span></Tooltip>} >
                                                                    <label className='text-primary font-w500 fs-7'>{data.raw_material_brand_name ? data.raw_material_brand_name : '-'}</label>
                                                                </OverlayTrigger>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    {/* Stock Room */}
                                                    <td>
                                                        <div className='text-primary fs-6 fw-semibold'>{data.stock_room_name || '-'}</div>
                                                    </td>

                                                    {/* Purchase & Expiry Dates */}
                                                    <td>
                                                        <div className='text-primary fs-6 fw-semibold'>{data.formatted_purchase_date}</div>
                                                        <div className='text-danger fs-6 fw-semibold'>{data.formatted_expiry_date}</div>
                                                    </td>

                                                    {/* Purchase Quantity */}
                                                    <td>
                                                        <div className='d-flex flex-row align-items-start justify-content-start gap-1'>
                                                            <label className='text-black font-w600 fs-7 rounded py-1 px-2 border border-info'>
                                                                {data.purchase_quantity} {data.purchase_unit}
                                                            </label>
                                                        </div>
                                                    </td>

                                                    {/* Vendor */}
                                                    <td className='text-center'>
                                                        <div className="d-flex align-items-start justify-content-start gap-2">
                                                            <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                                <div data-src={data.vendor_image ? data.vendor_image : staff2} className='border rounded px-1 py-0'>
                                                                    <img src={data.vendor_image ? data.vendor_image : staff2} alt={data.vendor_name} className='cursor-pointer w-50px h-50px' />
                                                                </div>
                                                            </LightGallery>
                                                            <div className='d-flex flex-column align-items-start'>
                                                                <label className='text-black font-w400 fs-7'>{data.vendor_name}</label>
                                                                <label className='text-dark font-w400 fs-7'>{data.vendor_category}</label>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    )
                                )}
                            </tbody>


                        </table>

                        <div className="d-flex justify-content-between align-items-center mt-3">
                        
                            {/* Bottom left: Showing x to y of z entries */}
                            <div>
                                {loading ? (
                                    <Skeleton width={200} height={16} />
                                ) : (
                                    datas.length > 0 ? (
                                        <span className="text-muted">
                                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                        </span>
                                    ) : (
                                        <span className="text-muted">
                                            Showing 0 to 0 of 0 entries
                                        </span>
                                    )
                                )}
                            </div>
    
                            {/* Bottom right: Pagination */}
                            <nav>
                                {loading ? (
                                    <div className="d-flex gap-1">
                                        {[...Array(5)].map((_, i) => (
                                            <Skeleton key={i} width={30} height={30} />
                                        ))}
                                    </div>
                                ) : (
                                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                        {/* Previous Button */}
                                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                Previous
                                            </button>
                                        </li>
    
                                        {/* First Page */}
                                        <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                1
                                            </button>
                                        </li>
    
                                        {/* Left Ellipsis */}
                                        {page > 4 && (
                                            <li className="page-item disabled">
                                                <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                            </li>
                                        )}
    
                                        {/* Pages Around Current */}
                                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                                            .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                            .map(p => (
                                                <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                        {p}
                                                    </button>
                                                </li>
                                            ))}
    
                                        {/* Right Ellipsis */}
                                        {page < totalPages - 3 && (
                                            <li className="page-item disabled">
                                                <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                            </li>
                                        )}
    
                                        {/* Last Page */}
                                        {totalPages > 1 && (
                                            <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                    {totalPages}
                                                </button>
                                            </li>
                                        )}
    
                                        {/* Next Button */}
                                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                )}
                            </nav>
    
                        </div>

                    </div>

                </Col>
            </Row>

                                    
        </>
    )


}
export default StockIn;